import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNVaccineSchema extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNVaccineSchema';
    }

    public clone(): any {
        return new CNVaccineSchema();
    }
}
